import { Apple, Play } from "lucide-react";

export const AppStoreSection = () => (
  <section id="appstore" className="scroll-mt-20 bg-teal-950 py-20 lg:py-28">
    <div className="mx-auto flex max-w-6xl flex-col items-center gap-10 px-5 text-center lg:flex-row lg:items-center lg:gap-16 lg:text-left">
      <div className="shrink-0">
        <img
          src="/wokivo-logo.png"
          alt="Wokivo App-Icon"
          className="h-28 w-28 rounded-[22%] shadow-xl ring-2 ring-white/20 sm:h-36 sm:w-36"
        />
      </div>
      <div className="max-w-xl">
        <h2
          data-testid="appstore-headline"
          className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl"
        >
          Bald im App Store
        </h2>
        <p className="mt-4 text-base leading-relaxed text-teal-100/80 sm:text-lg">
          Wokivo erscheint bald für iOS und Android. Schau gerne bald wieder
          vorbei – Woki kann es kaum erwarten, mit euch das nächste
          Abenteuer zu planen.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4 lg:justify-start">
          <div
            data-testid="badge-app-store"
            className="flex cursor-not-allowed items-center gap-3 rounded-2xl border border-white/20 bg-white/5 px-6 py-3 opacity-80"
          >
            <Apple className="h-7 w-7 text-white" />
            <span className="text-left">
              <span className="block text-[11px] font-semibold uppercase tracking-wider text-teal-200/70">
                Bald verfügbar im
              </span>
              <span className="block text-lg font-extrabold leading-tight text-white">
                App Store
              </span>
            </span>
          </div>
          <div
            data-testid="badge-google-play"
            className="flex cursor-not-allowed items-center gap-3 rounded-2xl border border-white/20 bg-white/5 px-6 py-3 opacity-80"
          >
            <Play className="h-7 w-7 text-white" />
            <span className="text-left">
              <span className="block text-[11px] font-semibold uppercase tracking-wider text-teal-200/70">
                Bald verfügbar bei
              </span>
              <span className="block text-lg font-extrabold leading-tight text-white">
                Google Play
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
);
